// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // filestorage: 'http://192.168.1.105:8015',
  url: 'https://backend.habitatnutrition.life/api', // URL BACKEND

  filestorage: 'https://backend.habitatnutrition.life',
  // url: 'https://backend.habitatnutrition.life/api', // URL BACKEND

  url_direct_debit: 'https://backend.habitatnutrition.life/api', // URL DIRECT DEBIT
  app_name: 'Habitat Nutrition Dashboard',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
